/**
 * CompactAttractionRow — compact 3-column flex row for visit detail.
 * Fits ≤80px height at 375px viewport width.
 * Left: attraction name. Middle: relative wait bar. Right: WaitTimeIndicator.
 */
import React from 'react';
import { WaitTimeIndicator } from './WaitTimeIndicator';

export interface CompactAttractionRowProps {
  attractionName: string;
  attractionId?: string;
  waitMinutes: number | null;
  isCompleted: boolean;
  isShortestWait: boolean;
  entityType?: string;
}

export function CompactAttractionRow({
  attractionName,
  attractionId,
  waitMinutes,
  isCompleted,
  isShortestWait,
  entityType,
}: CompactAttractionRowProps): React.ReactElement {
  return (
    <div
      className={`flex items-center gap-3 px-3 py-2.5 bg-white dark:bg-surface-dark-card rounded-lg min-h-[56px]${
        isShortestWait ? ' border-l-2 border-emerald-500' : ''
      }${isCompleted ? ' opacity-50' : ''}`}
    >
      {/* Left: attraction name + entity type */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5 min-w-0">
          <span
            className={`text-sm font-medium truncate${
              isCompleted
                ? ' line-through text-gray-400 dark:text-gray-500'
                : ' text-gray-900 dark:text-gray-100'
            }`}
          >
            {attractionName}
          </span>
          {isShortestWait && !isCompleted && (
            <span className="flex-shrink-0 text-[10px] font-semibold bg-emerald-50 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-400 px-1.5 py-0.5 rounded-full ring-1 ring-emerald-200 dark:ring-emerald-700/60">
              Best
            </span>
          )}
        </div>
        {entityType && (
          <span className="text-[11px] text-gray-400 dark:text-gray-500 mt-0.5 block">{entityType}</span>
        )}
      </div>

      {/* Right: WaitTimeIndicator */}
      <div className="flex-shrink-0">
        <WaitTimeIndicator minutes={waitMinutes} attractionId={attractionId} />
      </div>
    </div>
  );
}
